import React, { useEffect } from "react";
import { ArrowLeft } from "lucide-react";

export default function Modal({ title, onClose, children, bare }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[90] flex flex-col bg-[var(--rc-bg)] text-[var(--rc-text)] rc-pop" data-testid="modal-overlay">
      <div className="flex items-center gap-3 px-4 py-4 border-b border-[var(--rc-border)] bg-[var(--rc-bg)]/90 backdrop-blur-xl">
        <button onClick={onClose} className="h-9 w-9 grid place-items-center rounded-full text-[var(--rc-silver)] hover:text-[var(--rc-gold)] hover:bg-[var(--rc-surface)]" data-testid="modal-close-btn">
          <ArrowLeft size={22} />
        </button>
        <h3 className="font-heading text-2xl truncate">{title}</h3>
      </div>
      {bare ? (
        <div className="flex-1 min-h-0 flex flex-col">{children}</div>
      ) : (
        <div className="flex-1 overflow-y-auto no-scrollbar">
          <div className="max-w-2xl mx-auto w-full p-5 rc-safe-bottom">{children}</div>
        </div>
      )}
    </div>
  );
}
